import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class TimeQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.TIME;
  format: string;
  placeholder: string;
  cancelText: string;
  doneText: string;

  constructor(options: any = {}) {
    super(options);
    this.format = options['format'] || 'HH:mm';
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.doneText = options['doneText'] || 'OK';
  }
}
